async function fetchProductData(productIds) {
  // if (!productIds) return new Map();
  if (!productIds) {
    return {
      lookup: new Map(),
      emptyProductList: []
    };
  }

  try {

      const xapiPrefix = window.location.hostname === 'www.macys.com' ? 'https://www.macys.com/xapi/digital/v1/product' : 'https://www.mcom-012.tbe.zeus.fds.com/xapi/digital/v1/product';
      const result = await (await fetch(`${xapiPrefix}/${productIds}`)).json();
   
    const lookup = new Map();
    const requestedIds = Array.isArray(productIds)
      ? productIds.map(Number)
      : String(productIds).split(',').map(id => parseInt(id, 10));

    // result.product.forEach(product => lookup.set(product.id, product));
  //       result.product.forEach(product => lookup.set(product.id, {
  //     "url":product.identifier.productUrl,
  //   "brand":product.detail.brand.name,
  // "detail":product.detail.completeName}));

  //   return lookup;
    result.product.forEach(product => {
      const id = product.id;
      const url = product.identifier && product.identifier.productUrl ? product.identifier.productUrl : undefined;
      const brand = product.detail && product.detail.brand ? product.detail.brand.name : undefined;
      const detail = product.detail && product.detail.completeName ? product.detail.completeName : undefined;

     lookup.set(id, {
        url,
        brand,
        detail
      });
  });

      const emptyProductList = requestedIds.filter(
      id => !lookup.has(id)
    );

      return {
        lookup,
        emptyProductList
      };

  } catch (err) {
    console.error("Failed to fetch hotspot API data:", err);
    // return new Map();
    return {
      lookup: new Map(),
      emptyProductList: []
    };
  }
}

function getUniqueProductIds(selector) {
  selector = selector || '.hotspot'; // default value
  var elements = Array.prototype.slice.call(document.querySelectorAll(selector));
  var uniqueIds = {};
  var uniqueIdsArray = [];

  for (var i = 0; i < elements.length; i++) {
    var id = elements[i].dataset.name;

    if (id && !uniqueIds[id]) {
      uniqueIds[id] = true;
      uniqueIdsArray.push(id);
    }
  }

  return uniqueIdsArray.join(',');
}


module.exports = {
  fetchProductData,
  getUniqueProductIds
};
